import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { UsersService } from '../users/users.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private restoring: Promise<boolean> | null = null;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
  ) {}

  // An expired access token may still be refreshable, and only a request going through the interceptor proves it.
  public restore(): Promise<boolean> {
    if (this.authService.isAuthenticated()) {
      return Promise.resolve(true);
    }
    if (!this.authService.getRefreshToken()) {
      return Promise.resolve(false);
    }
    if (!this.restoring) {
      this.restoring = this.usersService
        .getLoggedUser()
        .then(() => true)
        .catch(() => false)
        .finally(() => {
          this.restoring = null;
        });
    }
    return this.restoring;
  }
}
